import initialState from './initialState'

const SET_CURRENT_LIST = (state, list) => {
    state.currentList = list
}
const SET_CURRENT_MODEL = (state, model) => {
    state.model = model
}
const SET_CURRENT_PAGINATION = (state, pagination) => {
    state.pagination = pagination
}

/**
 * @description
 * Returns State to it's initial values
 * @param {*} state
 */
const RESET_STATE = function(state) {
    Object.assign(state, initialState())
}

export default {
    RESET_STATE,
    SET_CURRENT_LIST,
    SET_CURRENT_MODEL,
    SET_CURRENT_PAGINATION,
}
